import * as React from "react";
import { Mail, Phone, MapPin, Building2, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function ImprintAndCompanyDetails() {
  const legalSections = [{
    title: "Firmeninformationen",
    icon: Building2,
    content: [{
      label: "Firmenname",
      value: "Münsterland Industrieservice UG (haftungsbeschränkt)"
    }, {
      label: "Geschäftsführer",
      value: "Yevhen Bulda"
    }, {
      label: "Registergericht",
      value: "Amtsgericht Coesfeld"
    }, {
      label: "Registernummer",
      value: "HRB 22918"
    }, {
      label: "USt-IdNr.",
      value: "DE454728639"
    }, {
      label: "Steuernummer",
      value: "312/5818/1773"
    }]
  }, {
    title: "Kontaktdaten",
    icon: Phone,
    content: [{
      label: "Adresse",
      value: "Grüner Weg 60, 48329 Havixbeck"
    }, {
      label: "Telefon",
      value: "+49 170 294 9140",
      href: "tel:+491702949140"
    }, {
      label: "E-Mail",
      value: "muensterland.is@gmail.com",
      href: "mailto:muensterland.is@gmail.com"
    }]
  }, {
    title: "Verantwortlich für den Inhalt",
    icon: MapPin,
    content: [{
      label: "Name",
      value: "Yevhen Bulda"
    }, {
      label: "Anschrift",
      value: "Grüner Weg 60, 48329 Havixbeck"
    }]
  }];
  const bankInfo = {
    title: "Bankverbindung",
    icon: CreditCard,
    content: [{
      label: "Bank",
      value: "Sparkasse Westmünsterland"
    }, {
      label: "IBAN",
      value: "DE20 4015 4530 0036 2888 50"
    }, {
      label: "BIC",
      value: "WELADE3WXXX"
    }]
  };
  const additionalInfo = [{
    title: "Haftungsausschluss",
    text: "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen."
  }, {
    title: "Urheberrecht",
    text: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet."
  }];
  return <section className="bg-background py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-12 animate-fade-in-up">
          <h1 className="text-4xl font-bold text-foreground sm:text-5xl lg:text-6xl">
            Impressum
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Angaben gemäß § 5 TMG
          </p>
        </div>

        {}
        <div className="mb-8 grid gap-6 animate-fade-in-up-delay-100 sm:grid-cols-1 lg:grid-cols-3">
          {legalSections.map((section, i) => {
          const IconComponent = section.icon;
          return <Card key={i} data-index={i} className="card border border-border shadow-soft">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-xl">
                    <IconComponent className="size-5 text-primary shrink-0" />
                    {section.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <dl className="space-y-3">
                    {section.content.map((item, j) => <div key={j} data-index={j}>
                        <dt className="text-sm font-medium text-muted-foreground">
                          {item.label}
                        </dt>
                        <dd className="mt-1 text-base text-foreground font-medium">
                          {item.href ? <Link to={item.href} className="transition-colors hover:text-primary">
                              {item.value}
                            </Link> : item.value}
                        </dd>
                      </div>)}
                  </dl>
                </CardContent>
              </Card>;
        })}
        </div>

        {}
        <div className="mb-12 animate-fade-in-up-delay-100">
          <Card className="card border border-border shadow-soft">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-xl">
                <CreditCard className="size-5 text-primary shrink-0" />
                {bankInfo.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <dl className="grid gap-4 sm:grid-cols-3">
                {bankInfo.content.map((item, i) => <div key={i} data-index={i}>
                    <dt className="text-sm font-medium text-muted-foreground">
                      {item.label}
                    </dt>
                    <dd className="mt-1 text-base text-foreground font-medium">
                      {item.value}
                    </dd>
                  </div>)}
              </dl>
            </CardContent>
          </Card>
        </div>

        {}
        <div className="mb-12 animate-fade-in-up-delay-100">
          <Card className="card border-2 border-primary/30 shadow-medium bg-primary/5">
            <CardContent className="py-6">
              <p className="text-center text-lg font-semibold text-foreground">
                Registereintrag: <span className="text-primary">HRB 22918, Amtsgericht Coesfeld</span>
              </p>
            </CardContent>
          </Card>
        </div>

        {}
        <div className="space-y-8 animate-fade-in-up-delay-200">
          {additionalInfo.map((info, i) => <Card key={i} data-index={i} className="card border border-border shadow-soft">
              <CardHeader>
                <CardTitle className="text-xl">{info.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-base leading-relaxed text-muted-foreground">
                  {info.text}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="mt-12 flex flex-col items-center justify-center gap-4 rounded-lg bg-muted-light p-8 text-center shadow-soft sm:flex-row border border-border">
          <p className="text-lg text-foreground font-medium">
            Haben Sie Fragen? Kontaktieren Sie uns gerne.
          </p>
          <Link to="/KontaktPage">
            <Button className="btn-primary">
              <Mail className="size-4" />
              Kontakt aufnehmen
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}